export class ShopHelpers {
	constructor() {
		/* переменная для проверки мобилки или десктопа */
		this.isDesktop = window.matchMedia("(min-width: 768px)");
	}

	/**
	 * Функция подствляет правильное окончание слова в зависимости от числа
	 * @param {Number} n
	 * @param {Array} forms
	 * @return {String}
	 * wordEnding(42, ["арбуз", "арбуза", "арбузов"]);
	 * 42 арбуза
	 */
	wordEnding(n, forms) {
		n = Math.abs(n) % 100;
		let n1 = n % 10;
		if (n > 10 && n < 20) {
			return forms[2];
		}
		if (n1 > 1 && n1 < 5) {
			return forms[1];
		}
		if (n1 === 1) {
			return forms[0];
		}
		return forms[2];
	}

	/**
	 * Функция вызывает callback через промежуток времени
	 * @param {Fucntion} callee - функция, которую надо «откладывать»;
	 * @param {Number} timeoutMs - интервал времени, спустя которое функцию следует вызывать.
	 * @return {Fucntion}
	 */
	debounce(callee, timeoutMs) {
		// Как результат возвращаем другую функцию.
		return function perform(...args) {
			// временная метка предыдущего вызова...
			let previousCall = this.lastCall;

			// в переменной текущего вызова — временная метка нынешнего момента.
			this.lastCall = Date.now();

			// Если разница между вызовами меньше, чем указанный интервал, то очищаем таймаут...
			if (previousCall && this.lastCall - previousCall <= timeoutMs) {
				clearTimeout(this.lastCallTimer);
			}

			this.lastCallTimer = setTimeout(() => callee(...args), timeoutMs);
			// Если таймаут был очищен, вызова не произойдёт;
			// если он очищен не был, то callee вызовется.
		};
	}

	setWindowScroll(scroll = 0) {
		window.scrollTo({
			top: scroll,
			behavior: "smooth",
		});
	}

	isNumber(n) {
		return !isNaN(parseFloat(n)) && !isNaN(n - 0);
	}

	isHTML(str) {
		const doc = new DOMParser().parseFromString(str, "text/html");
		return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
	}

  transformSingleNumberToTwoDigit(singleNumber) {
    return singleNumber < 10 ? `0${singleNumber}` : `${singleNumber}`;
  }
}

export const helpers = new ShopHelpers();
